import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'Angular Testing',
                topics: [
                    'The State of end-to-end testing with Angular- prepare for Protractor deprecation',
                    'New way of debugging template syntax errors with ng-template-error',
                ],
            },
            {
                title: 'Components',
                topics: [
                    'Component scoped keyframes',
                    'Creating a Dynamic forms using Standalone components in Angular 14',
                    'Learn a new way to create highly customizable reusable components with Angular 14',
                ],
            },
            {
                title: 'Angular Router',
                topics: [
                    'New Router API for standalone components in Angular 14',
                    'Smaller bundle sizes with new provideRouter API Tree shaking',
                    'Dumping unnecessary boilerplates with new Functional router guards - lightweight, ergonomic, and more composable',
                    'Sequentially execution with composable functional guards',
                ],
            },
            {
                title: 'New rendering engine',
                topics: [
                    'How to use the Directive Composition API',
                ],
            },
            {
                title: 'Angular 14 Performance improvements',
                topics: [
                    'Lazy loading made easier',
                ],
            },
            {
                title: 'API',
                topics: [
                    'Ivy landmark: makes Angular ultra fast',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li p2' key={`getReady_li-${i + item}`}><span>[]</span> {item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>What event is about</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;